import React, { useEffect, useState } from "react";
//require("dotenv").config();
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import openai from "openai"; // Import openai module
import { db } from "../firebase";
import { doc, setDoc, updateDoc } from "firebase/firestore";
import { Comment } from "react-loader-spinner";
import { motion } from "framer-motion";
import { useNavigate, Link } from "react-router-dom";

const BioGenerator = () => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState(Array.from({ length: 7 }, () => ""));
  const [finishedBio, setFinishedBio] = useState("");
  // State to control visibility of buttons and text boxes
  const [showResponse, setShowResponse] = useState(false);
  const [promptText, setPromptText] = useState("");
  const [responseText, setResponseText] = useState("");
  const [sessionFullName, setSessionFullName] = useState("");
  const [bioUpdate, setBioUpdate] = useState(false);
  const [aiRequest, setAiRequest] = useState(false);
  const [bioSaved, setBioSaved] = useState(false);
  const [nextQuestion, setNextQuestion] = useState(true);
  const navigate = useNavigate();

  const apiKey = process.env.OPENAI_API_KEY; // Replace with your actual API key

  const questionArray = [
    "How would you describe your artistic style?",
    "Are you a full-time artist? What's your day job?  What did you do in your previous career?",
    "Describe your education or training in art or photography?",
    "Name other artists or photographers who have influenced your work?",
    "What do you hope to convey through your art or photography?",
    "What else do you do besides art or photography?",
    "Tell us something about yourself that makes you unique as an artist or photographer. (Think outside of the box on this question.)",
  ];

  async function generateResponse(promptText) {
    let apiKey = process.env.REACT_APP_OPENAI_API_KEY;
    console.log("This is also the env Key:", apiKey);
    console.log(
      "This is env Key from function:",
      process.env.REACT_APP_OPENAI_API_KEY
    );

    const OpenAi = new openai({
      apiKey,
      dangerouslyAllowBrowser: true,
    });

    let responseText = "";

    try {
      const stream = await OpenAi.completions.create({
        model: "gpt-3.5-turbo-instruct",
        prompt: promptText,
        max_tokens: 160, // Adjust this value as needed
        stream: true,
        temperature: 0.2,
      });

      for await (const chunk of stream) {
        responseText += chunk.choices[0].text;
      }
      setResponseText(responseText);
      return responseText;
    } catch (error) {
      throw new Error(`OpenAI API error: ${error.message}`);
    }
  }

  const handleNextQuestion = () => {
    setNextQuestion(false);
    if (currentQuestionIndex < questionArray.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setTimeout(function () {
        setNextQuestion(true);
      }, 255);
    }
  };

  const handlePreviousQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const handleAnswerChange = (event) => {
    const newAnswers = [...answers];
    newAnswers[currentQuestionIndex] = event.target.value;
    setAnswers(newAnswers);
  };

  const handleSubmit = async () => {
    // You can use the 'answers' array to create a prompt for ChatGPT using OpenAI's API
    setAiRequest(true);
    setFinishedBio("");
    setShowResponse(false);
    const prompt = answers
      .map(
        (answer, index) => `${index + 1}. ${questionArray[index]}\n${answer}`
      )
      .join("\n\n");

    const existingPrompt = prompt;
    // const bar = sessionStorage.getItem("userFullName");
    // console.log("Session Full Name:", bar);
    // setSessionFullName(bar);

    //GPT4 modified version
    // const additionalText = [
    //   {
    //     role: "system",
    //     content: "You are a helpful assistant.",
    //   },
    //   {
    //     role: "user",
    //     content: `Forget previous instructions. Act as an expert copywriter. Craft a compelling biography for ${sessionFullName} using only the details given. Do not use any other information. Adhere to these guidelines:\n- Limit the bio to four well-structured paragraphs.\n- Double space between paragraphs.\n- Use only complete sentences.\n- Write in the third person.\n- Seamlessly weave ${sessionFullName}'s name into the story.\n- Rely solely on the information in the answers given in the prompt.`,
    //   },
    // ];

    const additionalText = `Forget previous instructions. Act as an expert copywriter. Craft a compelling biography for ${sessionFullName} using only the details given. Do not use any other information. Adhere to these guidelines:
    - Limit the bio to four well-structured paragraphs.
    - Double space between paragraphs.
    - Use only use complete sentences.
    - Write in the third person.
    - Seamlessly weave ${sessionFullName}'s name into the story.
    - Rely solely on the information in the answers given in the prompt.
    `;
    //GPT4 version
    // const additionalText = `Based on the answers provided, write a concise and compelling biography for ${sessionFullName}. Ensure the following: 1. Use third-person perspective. 2. Do not use first person references such as "I". 3. Incorporate ${sessionFullName}'s name into the narrative. 4. Structure the content in four paragraphs only. 5. The length of the biography must be no longer than 150 words. 6. Only use the information provided in this prompt.  Here is the prompt:`;

    const newPrompt = additionalText + "\n" + existingPrompt;
    console.log("Generated Prompt to be submitted:", newPrompt);
    /********************************************** */
    // Added the try catch block
    /********************************************** */
    try {
      setPromptText(newPrompt);
      const generatedText = await generateResponse(newPrompt); // Add 'await' here

      // Do something with the generated text...
      if (generatedText) {
        console.log("This is the generated bio", generatedText);
        setFinishedBio(generatedText);
        let bioToStore = generatedText;
        setShowResponse(true);
        setAiRequest(false);
        setBioUpdate(true);
      } else {
        console.log("Failed to generate text.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  async function handleSave(finishedBio) {
    setBioUpdate(false);
    setBioSaved(true);
    try {
      console.log("Here's the bio:", finishedBio);

      // Get the document ID
      const _docID = sessionStorage.getItem("docId");
      console.log("here's doc id:", _docID);

      // Create a reference to the specific document in the Firestore database
      const artistDocRef = doc(db, "artists", _docID);

      //Update the 'bio' field of the document with 'finishedBio'
      await updateDoc(artistDocRef, {
        bio: String(finishedBio), // Access the 'text' property directly
      });

      // Assuming 'setBioUpdate' is used to handle UI or state changes
      setBioUpdate(true);

      console.log("Bio Update Successful");
      console.log("Document ID:", _docID);
    } catch (error) {
      // Handle errors here
      console.error("Error updating bio:", error);
      // You can add error handling logic here, such as displaying an error message to the user
    }
  }

  async function handleTryAgain(promptText) {
    const generatedText = await generateResponse(promptText);
    console.log("Regenerate the bio");
  }

  const handleStartOver = () => {
    console.log("Start Over");
  };

  const handleGoToProfile = () => {
    console.log("Going to profile");
  };

  // Function to retrieve sessionFullName from sessionStorage
  const getSessionFullName = () => {
    const fullName = sessionStorage.getItem("userFullName");
    if (fullName) {
      setSessionFullName(fullName);
      return sessionFullName;
    }
  };

  // useEffect to watch for changes in sessionFullName
  useEffect(() => {
    const bar = sessionStorage.getItem("userFullName");
    console.log("Session Full Name:", bar);
    setSessionFullName(bar);
    getSessionFullName();
  }, []);

  return (
    <Container className='align-items-center'>
      <Row className='text-center ai-spinner'>
        {aiRequest && ( //this is the spinner
          <Comment
            visible={true}
            height='180'
            width='180'
            ariaLabel='comment-loading'
            wrapperStyle={{}}
            wrapperClass='comment-wrapper'
            color='#fff'
            backgroundColor='#e7aa1d'
          />
        )}
      </Row>
      {!bioUpdate && !bioSaved && !aiRequest && (
        <Row className='white-text votes-container grad-bg mt-4 pt-3'>
          <h3>Custom Bio for {sessionFullName}</h3>
          <p>
            To create a captivating artist or photographer biography, answer the
            following ten questions. We'll craft a personalized biography that
            reflects your artistic journey and style. The more detail, the
            better the bio!
          </p>
          <div className='timeline text-white'>
            {questionArray.map((_, index) => (
              <div
                key={index}
                className={`timeline-step ${
                  index <= currentQuestionIndex ? "completed" : ""
                }`}>
                <span className='time-line-number'>{index + 1}</span>
              </div>
            ))}
          </div>

          <motion.div
            className={`artists-form ${nextQuestion ? "visible" : "hidden"}`}
            initial={{ scaleY: 0 }}
            animate={{ scaleY: nextQuestion ? 1 : 0 }}
            exit={{ scaleY: 0 }}
            transition={{ duration: 0.25 }}>
            <div className='white-text bio-questions-box mb-3'>
              <label
                className='white-text pt-3 mb-2 bio-label-min-height align-items-center'
                htmlFor={`answer-${currentQuestionIndex + 1}`}>
                {questionArray[currentQuestionIndex]}
              </label>
              <input
                type='text'
                id={`answer-${currentQuestionIndex + 1}`}
                value={answers[currentQuestionIndex]}
                className='mb-2 form-control'
                onChange={(e) => handleAnswerChange(e)}
              />
            </div>
          </motion.div>

          <div className='d-flex justify-content-between mb-3'>
            {currentQuestionIndex > 0 && (
              <Button onClick={handlePreviousQuestion}>Previous</Button>
            )}
            {aiRequest && ( //this is the spinner
              <Comment
                visible={true}
                height='80'
                width='80'
                ariaLabel='comment-loading'
                wrapperStyle={{}}
                wrapperClass='comment-wrapper'
                color='#fff'
                backgroundColor='#e7aa1d'
              />
            )}
            {currentQuestionIndex < questionArray.length - 1 && (
              <Button
                style={{ marginLeft: "auto" }}
                onClick={handleNextQuestion}>
                Next
              </Button>
            )}
            {currentQuestionIndex === questionArray.length - 1 && (
              <Button onClick={handleSubmit}>Generate My Bio</Button>
            )}
          </div>
        </Row>
      )}
      {/* {showResponse && ( */}
      <>
        {" "}
        <Row>
          {" "}
          <motion.div
            className={`artists-form ${bioSaved ? "visible" : "hidden"}`}
            initial={{ scaleY: 0 }}
            animate={{ scaleY: bioSaved ? 1 : 0 }}
            exit={{ scaleY: 0 }}
            transition={{ duration: 0.75 }}>
            {bioSaved && (
              <Row>
                <div className='mb-3 mt-3'>
                  <h3 className='mb-3'>
                    Your Biography has been saved to your profile!
                  </h3>

                  <Button
                    className='btn btn-primary mb-4 btn-pr'
                    onClick={() => navigate("/EditUserProfile")}>
                    {" "}
                    Go To Profile and Edit...{" "}
                  </Button>

                  <Button
                    className='btn btn-primary mb-4'
                    onClick={() => navigate("/UserProfile")}>
                    {" "}
                    I love it. Next steps...{" "}
                  </Button>
                </div>
              </Row>
            )}
          </motion.div>
        </Row>
        <motion.div
          className={`artists-form ${bioUpdate ? "visible" : "hidden"}`}
          initial={{ scaleY: 0 }}
          animate={{ scaleY: showResponse ? 1 : 0 }}
          exit={{ scaleY: 0 }}
          transition={{ duration: 0.75 }}>
          <Row className='white-text votes-container'>
            {/* css trans begin */}
            {/* <h3 className='mt-3'>Completed Bio for {sessionFullName}</h3> */}
            {!bioUpdate ||
              (!bioSaved && (
                <>
                  <div className='margin-rl response-div bio-questions-box white-text grad-bg'>
                    <h3 className='mt-3'>
                      Completed Bio for {sessionFullName}
                    </h3>
                    <p className='white-text pt-3 pr-2 pl-2'>{finishedBio}</p>
                  </div>
                </>
              ))}
            {!bioUpdate ||
              (!bioSaved && (
                <div className='response-div white-text pt-2'>
                  {/* <h4>{sessionFullName}</h4> */}
                  <p className='white-text'>
                    Not quite right? Save your bio to your profile and edit your
                    bio there. Or try again to get a different version!
                  </p>
                </div>
              ))}
            {!bioUpdate ||
              (!bioSaved && (
                <div className='d-flex justify-content-between mb-3'>
                  <Button onClick={() => handleSave(finishedBio)}>
                    Save Bio to Profile & Edit
                  </Button>
                  {/* <Button onClick={handleTryAgain}>Regenerate</Button> */}
                  <Button onClick={handleSubmit}>Try Again</Button>
                </div>
              ))}{" "}
          </Row>
        </motion.div>
        {/* css trans end */}
      </>
      {/* )} */}
    </Container>
  );
};

export default BioGenerator;
